import { _js } from '@ifixit/localize';
import * as React from 'react';
import { Italic } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { useEditorContext } from '../../editor_context';

export const ItalicButton = (props: any) => {
   const { editor } = useEditorContext();

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().toggleItalic().run()}
         isActive={editor.isActive('italic')}
         isDisabled={!editor.can().toggleItalic()}
         icon={<Italic />}
         title={_js('Italic')}
         shortcut={'i'}
      ></TiptapButton>
   );
};
